module.exports = __webpack_public_path__ + "static/writing-movies-for-fun-and-profit-e1086984324886fb2a71337cc12d7163.jpg";